import axiosInstance from "./AxiosInstance";

// Get Patient Objections List
// Accepts either patient_id or lead_id. If lead_id is provided it will be used.
export const getPatientObjectionsService = (patient_id, lead_id) => {
  const payload = {};
  if (lead_id) {
    payload.lead_id = lead_id;
  } else {
    payload.patient_id = patient_id;
  }

  return axiosInstance.post("admin/getPatientObjections", payload);
};

// Update Patient Objections (Add / Update / Remove All)
// Accepts either patient_id or lead_id. If lead_id is provided it will be used.
export const updatePatientObjectionsService = (patient_id, objection_ids, lead_id) => {
  // Convert array to comma-separated string
  const objectionIdsString = Array.isArray(objection_ids) ? objection_ids.join(",") : objection_ids;

  const payload = {
    objection_ids: objectionIdsString,
    patient_id: patient_id || "",
    lead_id: lead_id || "",
  };

  return axiosInstance.post("admin/updatePatientObjections", payload);
};
